import { Button, Grid, Typography, useTheme } from '@mui/material'
import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LabeledText } from '../../../../../components/CustomTypography'
import { DefaultLoader } from '../../../../../components/Loaders'
import { RightSlider } from '../../../../../components/sliders'
import { StyledCard } from '../../../../../components/StyledCard'
import { AppDispatch } from '../../../../../store'
import {
  PrivateFoundationActions,
  PrivateFoundationSelectors,
} from '../../../../../store/privateFoundation'
import { IOrganizationAddress } from '../../../../../types'
import { PrivateFoundation } from './PrivateFoundation'

interface IFormattedPF {
  _id: string
  organizationUrl: string
  organizationName: string
  organizationDescription: string
  disbursedCharitableAmount: number
  contributedCharityAmount: number
  formattedDisbursedCharityAmount: string
  formattedContributedCharityAmount: string
  organizationAddress: IOrganizationAddress
}

interface IPrivateFoundationsListProps {
  result: IFormattedPF[]
}

export const PrivateFoundationsList: FC<IPrivateFoundationsListProps> = ({ result }) => {
  const theme = useTheme()
  const dispatch = useDispatch<AppDispatch>()

  const [showFoundationDetail, setShowFoundationDetail] = useState(false)

  const foundationLoading = useSelector(PrivateFoundationSelectors.getLoading)

  const fetchPrivateFoundation = (foundationId: string) => {
    dispatch(PrivateFoundationActions.fetchPrivateFoundationAsync({ foundationId }))
    setShowFoundationDetail(true)
  }

  const onSliderClose = () => {
    setShowFoundationDetail(false)
    dispatch(PrivateFoundationActions.resetFoundation())
  }

  return (
    <>
      <RightSlider
        open={showFoundationDetail}
        setOpen={setShowFoundationDetail}
        outerBoxSx={{ width: '600px' }}
        closeButtonAction={onSliderClose}
      >
        {foundationLoading && <DefaultLoader />}
        {!foundationLoading && <PrivateFoundation />}
      </RightSlider>

      <Grid spacing={2} container>
        {result &&
          result.map((pf) => {
            return (
              <Grid key={pf._id} item xs={4}>
                <StyledCard
                  sx={{
                    p: 2,
                    minHeight: '230px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography
                    mb={2}
                    color="secondary"
                    fontSize="0.9rem"
                    fontWeight={theme.typography.fontWeightBold}
                  >
                    {pf.organizationName}
                  </Typography>

                  {/*<LabeledText*/}
                  {/*  label="focus"*/}
                  {/*  value={pf.organizationDescription}*/}
                  {/*  valueProps={{ fontSize: '0.9rem' }}*/}
                  {/*  rootContainerProps={{*/}
                  {/*    gap: '0.2rem',*/}
                  {/*    alignItems: 'flex-start',*/}
                  {/*    direction: 'column',*/}
                  {/*  }}*/}
                  {/*/>*/}

                  <LabeledText
                    label="Total Grants Paid"
                    value={`$${pf.formattedDisbursedCharityAmount}`}
                    valueProps={{ fontSize: '0.9rem' }}
                    rootContainerProps={{
                      my: 1,
                      gap: 0,
                      alignItems: 'flex-start',
                      direction: 'column',
                    }}
                  />

                  <Button
                    variant="outlined"
                    disableElevation
                    color="secondary"
                    sx={{
                      mt: 2,
                      height: '36px',
                      color: 'secondary',
                      background: 'white',
                      borderRadius: '8px',
                      fontSize: '0.857rem',
                      textTransform: 'none',
                      letterSpacing: '0.2px',
                      borderColor: theme.palette.grey[300],
                    }}
                    onClick={() => fetchPrivateFoundation(pf._id)}
                  >
                    Foundation info
                  </Button>
                </StyledCard>
              </Grid>
            )
          })}
      </Grid>
    </>
  )
}
